import request from '@/utils/request'

// 保存分类
export function reqAddCategory(data) {
  return request({
    url: '/admin/jobCategory/save',
    method: 'post',
    data
  })
}

// 分类列表
export function reqCategoryList(data) {
  return request({
    url: '/admin/jobCategory/list',
    method: 'post',
    params: data
  })
}
// 更新分类
export function reqUpdateCategory(data) {
  return request({
    url: '/admin/jobCategory/update',
    method: 'post',
    data
  })
}

// 删除分类
export function reqDeleteCategory(data) {
  return request({
    url: '/admin/jobCategory/delete',
    method: 'post',
    data
  })
}

// 保存招聘职位
export function reqAddJobTitle(data) {
  return request({
    url: '/admin/JobTitle/save',
    method: 'post',
    data
  })
}

// 招聘职位列表
export function reqJobTitleList(data) {
  return request({
    url: '/admin/JobTitle/listConditions',
    method: 'post',
    params: data
  })
}
// 更新招聘职位
export function reqUpdateJobTitle(data) {
  return request({
    url: '/admin/JobTitle/update',
    method: 'post',
    data
  })
}

// 删除招聘职位
export function reqDeleteJobTitle(data) {
  return request({
    url: '/admin/JobTitle/delete',
    method: 'post',
    data
  })
}

// 保存广告
export function reqAddAd(data) {
  return request({
    url: '/admin/ad/save',
    method: 'post',
    data
  })
}

// 广告列表
export function reqAdList(data) {
  return request({
    url: '/admin/ad/list',
    method: 'post',
    params: data
  })
}
// 更新广告
export function reqUpdateAd(data) {
  return request({
    url: '/admin/ad/update',
    method: 'post',
    data
  })
}

// 删除招聘职位
export function reqDeleteAd(data) {
  return request({
    url: '/admin/ad/delete',
    method: 'post',
    data
  })
}
